const post = (data) => {
  const text    = window.encodeURIComponent(data)
  const url     = window.location.href
  const link    = `https://twitter.com/intent/tweet?text=${text}&url=${url}`

  const windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes'
  const width = 550
  const height = 253
  const minWidth = window.screen.width
  const minHeight = window.screen.height

  const left = Math.round((minWidth / 2) - (width / 2))
  const top = minHeight > height ? Math.round((minHeight / 2) - (height / 2)) : 0

  window.open(link, 'intent', `${windowOptions},width=${width},height=${height},left=${left},top=${top}`)
}


export default {
  post,
}
